import React, { useEffect, useState } from "react";
import { Form, Select, Button, Row, Col, Grid } from "antd";
import { useTranslation } from "react-i18next";
import { PlusCircleOutlined } from "@ant-design/icons";
import styles from "./../../style.module.scss";
import { setDeviceId, setTicketVisible } from "../../goSlice";
import { useAppSelector, useAppDispatch } from "store/hook";
import { DownloadOutlined } from "@ant-design/icons";

const { Option } = Select;
const { useBreakpoint } = Grid;

function Profile(props: any) {
  const [form] = Form.useForm();
  const screens = useBreakpoint();

  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { deviceId, ticketData } = useAppSelector((state) => state.goPage);

  return (
    <>
      {ticketData?.ticket_inf?.ticket_type === "installation" && (
        <div className={`${styles.Card_profile} ${styles.Card}`}>
          {/* <Row gutter={screens.xs ? {} : [48, 8]} align="middle" justify={screens.xs ? "space-between" : "center"}>
            <Col>
              <Row gutter={8}>
                <Col>
                  <Button
                    type="primary"
                    // className={styles.goDeviceButton}
                    // key={index}
                    onClick={() => {
                      // dispatch(setTicketVisible(true));
                      // dispatch(setAddOrUpdate("add"));
                    }}
                  >
                    General Profile
                  </Button>
                </Col>

                <Col>
                  <Button
                    type="primary"
                    // className={styles.goDeviceButton}
                    // key={index}
                    onClick={() => {
                      // dispatch(setTicketVisible(true));
                      // dispatch(setAddOrUpdate("add"));
                    }}
                  >
                    Ticket Profile
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row> */}
          <Row className={styles.Card_profile__desc} align="middle" justify="start">
            <Col span={24}>新增前置作業說明:</Col>
            <Col span={24}>
              步驟1: 點選下載
              <Button
                type="link"
                // onClick={}
              >
                Ticket Profile
                <DownloadOutlined />
              </Button>
            </Col>
            <Col span={24}>
              步驟2: 先將設備上電, 接著筆電使用網路線連接到欲新增設備, 並依照下方步驟將 Ticket Profile 載入設備.
            </Col>
            <Col span={24}>步驟3: 使用行動裝置開啟 O'smart GO 頁面, 確認設備是否上線.</Col>
          </Row>
        </div>
      )}
    </>
  );
}

export default Profile;
